// extracted by mini-css-extract-plugin
export default {"container":"_2NPdx4tghy","message":"_8gzPxjR-As"};
    if(module.hot) {
      // 1627035632745
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  